<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Material</th>
                <th :class="StyleTh">Unidad</th>
                <th :class="StyleTh">Sub Unidad</th>
                <th :class="StyleTh">Cantidad</th>
                <th :class="StyleTh">Precio</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
            </template>
            <template slot="body">
                <tr v-for="(item,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><p :class="StylePr">{{ item.NombreMaterial }}</p></td>
                    <td><h6 :class="StylePr">{{ item.Nombre }}</h6></td>
                    <td><p :class="StyleTd">{{ item.Cantidad + ' ' + item.SubUnidad }}</p></td>
                    <td><p :class="StyleTd">{{ item.CantidadProductos }}</p></td>
                    <td><p :class="StyleTd">$ {{ item.PrecioTotal }}</p></td>
                    <td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="item.IdProductoPresentacion" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">
                            </template>
						</CBtnAccion>
					</td>
                </tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="8"></CSinRegistros>
            </template>
        </CList>
        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
            <template slot="Form">
                <FormModal :poBtnSave="oBtnSave"></FormModal>
            </template>
        </CModal>
    </div>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
import FormModal from '@/views/modulos/almacen/productoPresentacion/ProductoPresentacionModal.vue';
const EmitEjecuta = 'seccionProductoPresentacion';
const EmitEjecuta2 = 'seccionProductoPresentacionEditar';
// const EmitEjecuta2 = 'seccionProductoPresentacionEditar';
export default {
    name: 'ListaProductoPresentacion',
    props: ['sFiltros','pOrigen'],
    components:{FormModal},
    data() {
        return {
            ConfigList:{
                Title: 'Listado',
                IsModal: false,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta2,
                BtnReturnShow: true,
                TitleFirst: 'Producto - Material',
                GoRoute:'ProductoPresentacionForm',
                Obj:{}
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Formulario",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta2,
                Obj:{objProductoPresentacion:{}},
                ModalSize:'lg'
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ObjProducto: {}
        }
    },
    methods: {
        async Lista()
        {
            this.ConfigList.ShowLoader = true;

            this.$http.get("productoPresentaciones",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Pag: this.Filtro.Pagina,
                    Entrada: this.Filtro.Entrada,
                    IdProducto: this.ObjProducto.IdProducto,
                }
            }).then((res)=>{

                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;

            }).finally(()=>{
                this.ConfigList.ShowLoader=false;
            })
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('productoPresentaciones/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'Producto',params:{}});
        },
    },
    created()
    {
        if(this.pOrigen!=undefined){
            sessionStorage.setItem('objProducto',JSON.stringify(this.pOrigen));
        }

        this.ObjProducto = JSON.parse(sessionStorage.getItem('objProducto'));
        this.ConfigList.Title = this.ConfigList.Title+' '+this.ObjProducto.Nombre;

        this.bus.$off('List_'+EmitEjecuta2);
        this.bus.$off('Delete_'+EmitEjecuta2);
        this.bus.$off('EmitReturn');
    },
    mounted() {
        this.Lista();

        this.bus.$on('List_'+EmitEjecuta2,()=>
        {
            this.Lista();
        });
        this.bus.$on('Delete_'+EmitEjecuta2,(Id)=>
        {
            this.Eliminar(Id);
        });
        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
}
</script>